import * as UrlUtils from "./urlUtils";

export const ActivityNavigationUtility = {
  ...UrlUtils,
};
